// src/components/modal/MenuItemDetails/types.ts
import type { Branch, MenuItem } from "~/types/new_types";

export interface MenuItemDetailsModalProps {
  show: boolean;
  close: () => void;
  theme?:
    | Branch["theme"]
    | {
        primaryColor?: string;
        secondaryColor?: string;
        backgroundColor?: string;
        cardColor?: string;
        textColor?: string;
        borderColor?: string;
        borderRadius?: string;
        fontFamily?: string;
      };
  item: MenuItem | null;
  isFavorite?: boolean;
  toggleFavorite?: (e: React.MouseEvent) => void;
}

export interface MenuItemDetailsModalContentProps
  extends Omit<MenuItemDetailsModalProps, "item"> {
  item: MenuItem;
}

export interface ItemCard {
  id: string;
  name: string;
  variants: Record<string, any>;
  quantity: number;
}

export interface NormalizedTheme {
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  cardColor: string;
  textColor: string;
  borderColor: string;
  borderRadius: string;
  fontFamily: string;
}

export type TabType = "variant" | "details" | "ingredients" | "nutrition" | "dietary";

export interface TabConfig {
  id: TabType;
  label: string;
}

export const DEFAULT_THEME: NormalizedTheme = {
  primaryColor: "#3B82F6",
  secondaryColor: "#10B981",
  backgroundColor: "#F8FAFC",
  cardColor: "#FFFFFF",
  textColor: "#1F2937",
  borderColor: "#E5E7EB",
  borderRadius: "8px",
  fontFamily: "Inter, sans-serif",
};
